import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import VueRouter from "vue-router";
import router from "./router";
import { createPinia, PiniaVuePlugin } from "pinia";
import piniaPluginPersist from "pinia-plugin-persist";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
// 挂原型链 引入 api 接口
import api from "@/api/api";
import config from "././config/config";
Vue.prototype.$api = api;
Vue.prototype.$baseUrl = config.baseUrl;

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999, // 设置图片预览组件的层级，确保能在其他组件之上
    // inline: true,
    button: true,
    navbar: false,
    title: false,
    toolbar: false,
    tooltip: false,
    movable: false,
    zoomable: true,
    rotatable: false,
    scalable: false,
    transition: true,
    fullscreen: false,
    keyboard: false,
  },
});

Vue.config.productionTip = false;

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersist);

new Vue({
  router,
  pinia,
  store,
  Viewer,
  render: (h) => h(App),
}).$mount("#app");
